export type AgencyWorkModel = {
    id: number;
    name: string;
    textResourceKey: string;
  }
  
export enum AgencyWorkModelsEnum {
    OwnNameAndOwnInvoice = 1,
    OwnNameAndOtherInvoice = 2,
    OtherNameAndOtherInvoice = 3
}